import "./DataKitThumb.scss";

const PALETTE = [
  { bg: "#fff0f1", fg: "#e42436" },
  { bg: "#f9f0ff", fg: "#531dab" },
  { bg: "#f0f5ff", fg: "#1d39c4" },
  { bg: "#e6fffb", fg: "#08979c" },
  { bg: "#fff7e6", fg: "#d46b08" },
  { bg: "#f6ffed", fg: "#389e0d" },
];

export function dataKitThumbColors(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function DataKitThumb({ name, size = 48 }: { name: string; size?: number }) {
  const label = name.trim() || "Untitled";
  const initial = label.charAt(0).toUpperCase();
  const { bg, fg } = dataKitThumbColors(label);
  return (
    <span
      className="data-kit-thumb"
      style={{ background: bg, color: fg, width: size, height: size, flex: `0 0 ${size}px` }}
    >
      {initial}
    </span>
  );
}
